import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=57d0b4a9&scoped=true"
import script from "./step3.vue?vue&type=script&lang=ts"
export * from "./step3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d0b4a9",
  null
  
)

export default component.exports